import React from "react";
import { Reveal, SectionHeading } from "../shared/Primitives";
import { ArrowUpRight, Calendar, Tag, BookOpen } from "lucide-react";

export default function Blogs({ blogs = [] }) {
    const defaultBlogs = [
        {
            title: "Building Grounded RAG Systems That Don't Hallucinate",
            excerpt: "Practical architectural patterns for retrieval, semantic vector search guardrails, and deterministic evaluation in production health & enterprise RAG pipelines.",
            date: "2025-01-10",
            tag: "AI Engineering",
            url: "#"
        },
        {
            title: "QA for AI Products: Testing the Untestable",
            excerpt: "How to validate probabilistic LLM features using deterministic regression suites, semantic assertions, and automated Playwright workflows.",
            date: "2024-12-02",
            tag: "Enterprise QA",
            url: "#"
        },
        {
            title: "From Monolith to Modular: A Full-Stack Refactor",
            excerpt: "Lessons learned from scaling high-concurrency restaurant POS and inventory platforms into clean, typed, high-availability micro-services.",
            date: "2024-10-18",
            tag: "Full Stack Craft",
            url: "#"
        },
    ];

    const displayBlogs = blogs?.length ? blogs : defaultBlogs;

    return (
        <section className="max-w-6xl mx-auto px-5 py-24 md:py-32">
            <SectionHeading 
                id="blogs" 
                index="06 / Insights" 
                subtitle="Articles & Thinking" 
                title="Technical writing on AI systems, modern QA, and engineering architecture." 
            />

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {displayBlogs.map((article, index) => (
                    <Reveal key={article.title || index} delay={index * 0.1} className="flex flex-col">
                        <article className="glass rounded-3xl p-7 flex flex-col justify-between h-full hover:-translate-y-1.5 transition-all duration-300 group relative border border-border/60 hover:border-primary/40 shadow-sm hover:shadow-xl">
                            <div>
                                <div className="flex items-center justify-between gap-3 mb-4">
                                    <span className="inline-flex items-center gap-1.5 font-mono text-xs px-3 py-1 rounded-full bg-primary/10 text-primary font-medium">
                                        <Tag className="w-3 h-3" /> {article.tag || "Engineering"}
                                    </span>
                                    <span className="inline-flex items-center gap-1 font-mono text-xs text-muted-foreground">
                                        <Calendar className="w-3 h-3" /> {article.date || "2025"}
                                    </span>
                                </div>
                                
                                <h3 className="font-display text-xl font-bold mb-3 text-foreground group-hover:text-primary transition-colors leading-snug">
                                    {article.title}
                                </h3>
                                
                                <p className="text-sm text-muted-foreground leading-relaxed mb-6">
                                    {article.excerpt}
                                </p>
                            </div>

                            <div className="pt-4 border-t border-border/40 flex items-center justify-between text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                                <span className="flex items-center gap-2">
                                    <BookOpen className="w-4 h-4 text-accent" /> Read Article
                                </span>
                                <span className="w-8 h-8 rounded-full glass flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all">
                                    <ArrowUpRight className="w-4 h-4 transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                                </span>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
